<template>
  <div class="comContent">
    <div class="header">
      <el-form :inline="true" style="text-align: left">
        <el-row style="margin: 10px  0 10px">
          <el-form-item label="" prop="shopName">
            <el-input v-model.trim="formTool.shopName" style="width: 200px;" placeholder="请输入商户名称" clearable
              size="small" />
          </el-form-item>
          <el-form-item label="" prop="auditStatus">
            <el-select v-model="formTool.auditStatus" clearable style="width: 160px;" size="small" placeholder="请选状态">
              <el-option v-for="item in statusType" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="getList(1)">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="reset()">重置</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <myTable :index="index" :selection="false" :page="page" :showpage="true" :operation="false" v-loading="loading"
      :table-data="tableData" :table-option.sync="tableOption" @page-change="getList" :expand="false">

      <template slot="operation" slot-scope="scope">
        <div style="margin: 0 0px">
          <el-link type="primary" :underline="false" @click="HandlerClick(scope.row, 'detail')"
            style="margin-right: 10px">
            详情
          </el-link>
          <el-link type="primary" :underline="false" @click="HandlerClick(scope.row, 'audit')" style="margin-right: 10px"
            v-if="scope.row.auditStatus == 'AWAIT'">
            审核
          </el-link>
          <!-- phone -->
        </div>
      </template>
      <template slot="phone" slot-scope="scope">
        {{ scope.row.concatName }}
        {{ scope.row.concatPhone }}
      </template>
      <template slot="status" slot-scope="scope">
        {{ scope.row.auditStatus | statusType }}
      </template>
    </myTable>
  </div>
</template>
<script>

const statusType = [{
  value: 'NOT_PASS',
  label: '审核未通过',
}, {
  value: 'PASS',
  label: '审核通过',
}, {
  value: 'AWAIT',
  label: '待审核',
}]
import myTable from "@/components/myTable";
import { giftPayeeList } from "@/api/gift";
import { queryShopListAudit, auditShopInformation } from "@/api/shopmange";
// /shop/basic/information/sys/list
import { skuStatus } from '@/api/commodityList/index'
export default {
  components: { myTable },
  props: {},
  data () {
    return {
      expanded: false,
      isExpanded: false,
      loading: false,
      operation: true,
      selection: true,
      index: false,
      formTool: {},
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [{ id: 1 }],
      tableOption: [
        { label: "商户名称", prop: "shopName", },
        { label: "运营人员&联系方式", prop: "phone", slot: true },
        { label: "店铺名称", prop: "shopBasicName", },
        { label: "审核结果", prop: "status", slot: true },
        { label: "审核时间", prop: "auditTime", },
        { label: "提交时间", prop: "submitAuditTime", },
        { label: "操作", prop: "operation", slot: true },
      ],
      statusType: statusType
    };
  },
  filters: {
    statusType (e) {
      for (let i = 0; i < statusType.length; i++) {
        if (statusType[i].value == e) {
          return statusType[i].label
        };
      }

    }
  },
  created () { },
  mounted () {
    this.getList();
  },
  methods: {
    reset () {
      this.formTool = {};
      this.page.current = 1;
      this.getList();
    },
    getList (current) {
      if (current) {
        this.page.current
      }
      let params = {};
      if(current){
        this.page.current = current;
      }
      params.current = this.page.current;
      params.size = this.page.size;
      params = Object.assign(params, this.formTool)
      queryShopListAudit(params).then((res) => {
        if (res) {
          this.tableData = res.records;
          this.page.total = res.total;
        }
      }).catch((err) => { })
    },

    audit () {
      auditShopInformation(params).then((res) => { }).catch((err) => { })
    },

    UpdateStatus (row, type) {

    },
    HandlerClick (row, type) {
      this.$router.push(`./shopInfoAudit-shopDetail?type=${type}&shopId=${row.id}`);
    },

  },
};
</script>
<style lang="scss" scoped>
::v-deep.el-table {
  height: calc(100% - 138px) !important;
}

::v-deep.zt__table {
  height: calc(100% - 118px) !important;
}

::v-deep.el-table .el-table__body-wrapper {
  height: calc(100% - 78px) !important;
  overflow-y: scroll !important;
}

.expand-form {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.flex-box {
  display: flex;
  justify-content: space-between;
}
</style>
